import { cn } from "@/lib/utils"

export const tasksPageTheme = {
  pageContainer: "min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/90 to-indigo-950/80 p-6 md:p-8 lg:p-10",

  contentWrapper: "max-w-screen-2xl mx-auto px-4 sm:px-8 lg:px-16 xl:px-24",

  header: "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 mb-10",

  pageTitle: "text-4xl sm:text-5xl font-extrabold text-white tracking-tight drop-shadow-lg",

  actionsContainer: "flex flex-wrap gap-4",

  triggerButton: cn(
    "font-bold text-xl lg:text-2xl px-6 py-6 rounded-3xl shadow-lg shadow-purple-500/30",
    "transition-all duration-300 hover:scale-[1.03] hover:shadow-purple-600/40"
  ),

  createTaskButton: "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white",

  createBlockButton: "bg-gradient-to-r from-indigo-600 to-cyan-600 hover:from-indigo-700 hover:to-cyan-700 text-white",

  statisticsButton: "bg-gradient-to-r from-violet-600 to-fuchsia-600 hover:from-violet-700 hover:to-fuchsia-700 text-white",

  tabsList: "bg-purple-950/60 backdrop-blur-2xl border border-purple-300/40 rounded-3xl p-1.5 shadow-xl shadow-purple-500/20",

  tabsTriggerActive: cn(
    "rounded-3xl px-8 py-3 text-base font-medium transition-all duration-300",
    "data-[state=active]:bg-gradient-to-r data-[state=active]:from-purple-600 data-[state=active]:to-pink-600",
    "data-[state=active]:text-white data-[state=active]:shadow-lg data-[state=active]:shadow-purple-600/40",
    "hover:bg-purple-900/60 text-purple-200"
  ),

  tabsTriggerArchive: cn(
    "rounded-3xl px-8 py-3 text-base font-medium transition-all duration-300",
    "data-[state=active]:bg-gradient-to-r data-[state=active]:from-indigo-600 data-[state=active]:to-cyan-600",
    "data-[state=active]:text-white data-[state=active]:shadow-lg data-[state=active]:shadow-indigo-600/40",
    "hover:bg-indigo-900/60 text-indigo-200"
  ),

  loadingScreen: "min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-indigo-950 flex items-center justify-center",
  loadingText: "text-white text-3xl",
} as const